/**
 * Requests to `environment.newApiBackend` use absolute URLs and skip HttpUrlInterceptor,
 * which unwraps `response.body.data` for relative `/api/*` calls.
 * The mono API wraps payloads as `{ success: true, data: T, ... }`.
 */
export function unwrapNewApiEnvelope<T>(body: unknown): T {
  if (
    body !== null &&
    typeof body === 'object' &&
    'success' in body &&
    (body as { success?: unknown }).success === true &&
    'data' in body
  ) {
    return (body as { data: T }).data;
  }
  return body as T;
}
